import { render, staticRenderFns } from "./EmployeeDataTrainingEvents.vue?vue&type=template&id=c6980a76&"
import script from "./EmployeeDataTrainingEvents.vue?vue&type=script&lang=js&"
export * from "./EmployeeDataTrainingEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports